import { ConfirmationService } from 'primeng/api';
import { Component, OnInit, ViewChildren, QueryList, ViewChild, Input } from '@angular/core';
import { ItemConfirmComponent } from '@pages/_components/item-confirm/item-confirm.component';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { Table } from 'primeng/table';
import { TabPanelHandler } from '@core/_utils/table.utils';
import { CommonService } from '@service/common.service';
import { findItem, isInArrayKey } from '@core/_utils/tools.utils';
import { AuthService } from '@auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, lastValueFrom, map } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';

@Component({
    selector: 'app-list-editors',
    templateUrl: './list-editors.component.html',
    styleUrls: ['./list-editors.component.scss'],
})
export class ListEditorsComponent extends TabPanelHandler implements OnInit {
    public value = true;
    public itemConfirm: ItemConfirmComponent;
    public customEditorList = [];
    private isAdmin = false;

    protected _isInRangeTimeout: any;

    public listColumns = [];

    @ViewChildren('p-tabPanel:not(:first-child)')
    public itemChildren: QueryList<any>;

    @ViewChild('dt')
    public dataTable: Table;
    public blockEvent = false;

    @Input()
    public entities: Array<any> = [];

    constructor(
        public menu: MenuServiceInt,
        protected _messageService: MessagesService,
        public confirmationService: ConfirmationService,
        private commonService: CommonService,
        private api: ApiV6Service,
        private auth: AuthService,
        protected translate: TranslateService
    ) {
        super(translate);
        this.menu.display = true;
        this.isAdmin = this.auth.isAdmin();
    }

    ngOnInit() {
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.listColumns = [
            { header: this.translate.instant('Name'), field: 'label' },
            { header: this.translate.instant('Desc'), field: 'desc' },
        ];
        this.findAll();
        this.commonService.checkReset();
    }

    setFilteredList(event) {}

    private async findAll() {
        let wRes: any;
        let wIdx: number = 0;
        let wEditor = [];

        try {
            wRes = await lastValueFrom(this.readData());
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant(error.error.CodeMessage));
            return;
        }
        wEditor = wRes.getEditorRights.data;
        this.customEditorList = wRes.getCustomEditorlist.CustomEditorList.CustomEditor.filter((item) => {
            return (item.Information.Type_ === 'ComboCustom' || item.Information.Type_ === 'Combo')
        }).map((item) => {
            item.id = wIdx;
            item.name = item.Information.Name;
            item.label = item.Information.Name;
            item.value = item.Information.Name;
            item._label = item.Information.Name;
            item.reference = item.Information.Name;
            item.desc = this.getDescription(item);
            wIdx++;
            return item;
        });

        if (this.isAdmin === false) {
            this.customEditorList = this.customEditorList.filter((item) => {
                if (isInArrayKey(item.Information.Name, wEditor, 'name')) {
                    return item;
                }
            })
        }
    }

    private readData() {
        return forkJoin([
            this.api.getCustomEditorlist(),
            this.api.execUrlAction('geteditorrights', '')
        ]).pipe(
            map(([getCustomEditorlist, getEditorRights]) => {
                return {getCustomEditorlist, getEditorRights};
            })
        );
    }

    private getDescription(aItem) {
        if (Array.isArray(aItem.Information.Description)) {
            return '';
        } else {
            return aItem.Information.Description
        }
    }

    closeTab(event) {
        this.closeTabsheet(event);
        this.index = event.index - 1;
        this.execClose(event);
    }

    validateTab(event) {
        this.update(event);
    }

    private update(event) {
        let wIndex = findItem(this.customEditorList, event.id, 'id');
        if (wIndex !== -1) {
            if (event.data[0].Information.Type_ === 'ComboCustom') {
                this.customEditorList[wIndex].ComboCustom.Show = event.data[0].ComboCustom.Show;
                this.customEditorList[wIndex].ComboCustom.Value = event.data[0].ComboCustom.Value;
            } else {
                this.customEditorList[wIndex].Combo.Value = event.data[0].Combo.Value;
            }
        }
        this.closeTab(event);
    }

    addTab(event) {
    }

    cancelAdd(event) {
        this.closeTabsheet(this._event);
        this.index = this.index - 1;
    }

    handleChange($event) {
        this.index = $event.index;
    }

    confirmDelete(event) {
    }

    delete(event) {
    }

    showDetails(item) {
        item = item.data;
        if (!this.isAlreadySelected(item.id)) {
            this.addElement(item.id, item.name, item.reference);
        }
    }

    sortReference(event: any): void {}
}
